import React from "react";
import "./customLoaderLiquid.scss";

const CustomLoaderLiquid: React.FC = () => {
  // old loader
  // return (
  //   <div className="customLoaderLiquid m-auto flex w-auto justify-center justify-items-center">
  //     <div className="loader">
  //       <span style={{ "--i": 1 } as React.CSSProperties}></span>
  //       <span style={{ "--i": 2 } as React.CSSProperties}></span>
  //       <span style={{ "--i": 3 } as React.CSSProperties}></span>
  //       <span style={{ "--i": 4 } as React.CSSProperties}></span>
  //       <span style={{ "--i": 5 } as React.CSSProperties}></span>
  //       <span style={{ "--i": 6 } as React.CSSProperties}></span>
  //       <span style={{ "--i": 7 } as React.CSSProperties}></span>
  //     </div>
  //     <svg>
  //       <filter id="gooey">
  //         <feGaussianBlur in="SoueceGraphic" stdDeviation="10" />
  //         <feColorMatrix
  //           values="
  //             1 0 0 0 0
  //             0 1 0 0 0
  //             0 0 1 0 0
  //             1 0 0 20 -10
  //           "
  //         />
  //       </filter>
  //     </svg>
  //   </div>
  // );

  return (
    <div className="loader_liquid justify-center justify-items-center"></div>
  );
};

export default CustomLoaderLiquid;
